import { render, staticRenderFns } from "./wikiList.vue?vue&type=template&id=08917c86&"
import script from "./wikiList.vue?vue&type=script&lang=ts&"
export * from "./wikiList.vue?vue&type=script&lang=ts&"
import style0 from "./wikiList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports